// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__IGVF-","yellow":"style_yellow__1xTX4","green":"style_green__35VHx","round":"style_round__yhUpx"};